import { api } from './http';

export interface ILandingTokenResponse {
	token: string;
	expiresIn: number;
}

export async function fetchLandingToken() {
	const { data } = await api.post<ILandingTokenResponse>('/landing-token', {}, { suppressToast: true });
	return data;
}
